import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=6bda54b2&scoped=true"
import script from "./PagesList.vue?vue&type=script&lang=js"
export * from "./PagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda54b2",
  null
  
)

export default component.exports